import { ReactNode } from 'react';

import { CapsuleButton } from '@ui/components/CapsuleButton';
import { Card } from '@ui/components/Card';
import { SlimArrowButton } from '@ui/components/SlimArrowButton';
import { ArrowSlimIcon } from '@ui/icons/ArrowSlimIcon';

import styles from './PlayerEloStatsPreview.module.css';

type Props = {
  setIsModalOpen: (newValue: boolean) => void;
  children: ReactNode;
};
export function PlayerEloStatsPreview({ setIsModalOpen, children }: Props) {
  return (
    <Card className={styles.playerEloStatsPreview}>
      <div className={styles.header}>
        <div className={styles.title}>Рейтинг и партии</div>

        <SlimArrowButton
          colorPreset="golden"
          direction="right"
          size="20"
          onClick={() => setIsModalOpen(true)}
        />
      </div>

      <div className={styles.content}>{children}</div>

      <CapsuleButton
        className={styles.button}
        preset="hollow-golden"
        size="16r-32"
        onClick={() => setIsModalOpen(true)}
      >
        <span>История партий</span>
        <span className={styles.arrow}>
          <ArrowSlimIcon />
        </span>
      </CapsuleButton>
    </Card>
  );
}
